import { Variable } from './variable';
import { VariableType } from './variable-type.enum';
import { VariableValue } from './variable-value';

export class IndependentVariable extends Variable {
    constructor(index: number, key: string, values: VariableValue[]) {
       super(index, key, VariableType.Independent, key, values);
    }
}
